module.exports = __webpack_public_path__ + "img/trash.4845bdb6.svg";